import { PostWarning } from '../domain/dtos'

export const makePostCreateAlertData = (data: PostWarning) => ({
  alertType: data.alertType,
  userId: data.userId,
  productId: data.productId,
})
